import { IconPartner, IconSmallPartner } from '@hivebrite/design-system/Icon';

import type { BuilderComponent } from 'hb-builder/types';

const Partners: Partial<BuilderComponent> = () => <div />; // never used

Partners.componentCategory = 'block';
Partners.componentIcon = ({ config } = {}) =>
  config?.features?.panel?.applyNewDesign ? IconSmallPartner : IconPartner;
Partners.componentLabel = __('Logos');
Partners.componentName = 'Partners';
Partners.componentType = 'section';

Partners.canBeDoubleClicked = true;
Partners.canBeDragged = true;
Partners.canBeListed = true;
Partners.canBeSelected = true;
Partners.componentClickable = true;

export default Partners;
